// Remplace le H1 par les options de la variante sélectionnée (sans JSON, super fiable)
(function () {
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  // Trouver la zone produit et le H1
  const root = $('[id^="MainProduct-"]') || $('.product') || document;
  if (!root) return;

  const h1 =
    $('h1.product__title', root) ||
    $('.product__title h1', root) ||
    $('h1.product-title', root) ||
    $('h1[itemprop="name"]', root) ||
    $('h1', root);
  if (!h1) return;

  const baseTitle = h1.textContent.trim();

  // Récupère les textes visibles des options sélectionnées (radios + selects)
  function getOptionTexts() {
    const values = [];

    // Groupes d’options (Dawn)
    const groups = $all('.product-form__input', root);
    if (!groups.length) {
      // fallback si structure custom
      const radios = $all('input[type="radio"][name^="options"]', root);
      const selects = $all('select[name^="options"]', root);

      radios.filter(r => r.checked).forEach(r => values.push((r.value || '').trim()));
      selects.forEach(sel => {
        const opt = sel.options[sel.selectedIndex];
        values.push((opt && opt.text ? opt.text : '').trim());
      });
    } else {
      groups.forEach(g => {
        const checked = $('input[type="radio"]:checked', g);
        if (checked) {
          const lbl = g.querySelector(`label[for="${checked.id}"]`);
          const txt = (lbl?.textContent || checked.value || '').trim();
          if (txt && !/^default title$/i.test(txt)) values.push(txt);
          return;
        }
        const sel = $('select', g);
        if (sel) {
          const opt = sel.options[sel.selectedIndex];
          const txt = (opt && opt.text ? opt.text : '').trim();
          if (txt && !/^default title$/i.test(txt)) values.push(txt);
        }
      });
    }

    return values.filter(Boolean);
  }

  function updateTitle() {
    const vals = getOptionTexts();
    // Remplacer complètement le H1 par le libellé de la variante (ici, concat des options)
    h1.textContent = vals.length ? vals.join(' • ') : baseTitle;
  }

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTitle);
  } else {
    updateTitle();
  }

  // Écoutes : radios/selects, et événements émis par certains thèmes
  root.addEventListener('change', (e) => {
    if (e.target.closest('.product-form__input') || e.target.name?.startsWith('options')) {
      updateTitle();
    }
  });
  document.addEventListener('variant:change', updateTitle);
  document.addEventListener('variant-change', updateTitle);
})();
